var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvindarlig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 106,
    viewBox: "0 0 129 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.328 41.1992L128.653 26.8721L102.59 0.410156L89.18 13.7202C100.516 19.5532 109.497 29.3072 114.328 41.1992Z",
    fill: "#ED1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.285 13.7251L27.174 0.411133L0.822021 26.5601L15.232 40.9831C20.082 29.1911 29.019 19.5211 40.285 13.7251Z",
    fill: "#ED1C24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.057 29.8321C88.036 21.8141 76.98 16.8631 64.745 16.8621C52.51 16.8631 41.455 21.8151 33.432 29.8311C25.416 37.8531 20.465 48.9081 20.463 61.1441C20.465 73.3781 25.416 84.4331 33.432 92.4551C41.454 100.473 52.509 105.423 64.745 105.425C76.979 105.423 88.036 100.473 96.057 92.4551C104.075 84.4341 109.026 73.3791 109.028 61.1441C109.026 48.9071 104.075 37.8531 96.057 29.8321Z",
    fill: "#ED1C24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4001 77.262C81.4001 86.46 73.942 93.912 64.746 93.912C55.549 93.912 48.092 86.458 48.092 77.262C48.092 68.059 55.549 60.604 64.746 60.604C73.942 60.604 81.4001 68.061 81.4001 77.262Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.669 81.6881C74.5238 81.6881 76.838 79.3738 76.838 76.5191C76.838 73.6643 74.5238 71.3501 71.669 71.3501C68.8142 71.3501 66.5 73.6643 66.5 76.5191C66.5 79.3738 68.8142 81.6881 71.669 81.6881Z",
    fill: "#ED1C24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.826 81.6881C60.6807 81.6881 62.995 79.3738 62.995 76.5191C62.995 73.6643 60.6807 71.3501 57.826 71.3501C54.9712 71.3501 52.657 73.6643 52.657 76.5191C52.657 79.3738 54.9712 81.6881 57.826 81.6881Z",
    fill: "#ED1C24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.969 54.1229C86.601 54.1229 90.356 50.3679 90.356 45.7359C90.356 41.1039 86.601 37.3489 81.969 37.3489C77.337 37.3489 73.582 41.1039 73.582 45.7359C73.582 50.3679 77.337 54.1229 81.969 54.1229Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.836 48.3539H53.727C55.048 48.3539 56.12 47.2819 56.12 45.9609C56.12 44.6399 55.049 43.5679 53.727 43.5679H38.836C37.516 43.5679 36.444 44.6399 36.444 45.9609C36.444 47.2819 37.515 48.3539 38.836 48.3539Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.886 38.7799V53.1409C43.886 54.4609 44.958 55.5339 46.279 55.5339C47.6 55.5339 48.672 54.4619 48.672 53.1409V38.7799C48.672 37.4599 47.6 36.3879 46.279 36.3879C44.958 36.3879 43.886 37.4599 43.886 38.7799Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvindarlig);
export default __webpack_public_path__ + "static/media/svindarlig.c88c0c11bdf594ef796993841e758d80.svg";
export { ForwardRef as ReactComponent };